import {ReactNode, useEffect, useState} from "react";

import {Loader} from "@pg-design/loader-module";
import {noop} from "@pg-mono/nodash";
import {Country} from "@pg-rp/common-types";

import {rpFeatureFlagMultiLeadInsideConversations} from "../../../../../../app/read_rp_environment_variables";
import {IApplication} from "../../../../../../application/types/IApplication";
import {IMultiLeadStepPayload} from "../../../../../../application/types/IMultiLeadStepPayload";
import {ISetPreferencesStepPayload} from "../../../../../../application/types/ISetPreferencesStepPayload";
import {useGetPropertyDetailApplicationQuery} from "../../../../../../property/api/get_property_detail";
import {useLeadModalParamsRecommendations} from "../../../../../hooks/use_lead_modal_params_recommendations";
import {useOpenedLeadModalRequiredParams} from "../../../../../hooks/use_lead_modal_required_params";

interface IProps {
    sentApplication: IApplication | null;
    handleSetPreferencesStep: (payload: ISetPreferencesStepPayload) => void;
    handleSetMultiLeadStep: ((payload: IMultiLeadStepPayload) => void) | undefined;
    handleModalClose: (forceClose: boolean) => void;
    customLoader?: ReactNode;
    minLoaderDuration?: number;
}

export function LeadModalPriceConversationChatRedirect(props: IProps) {
    const {customLoader, minLoaderDuration = 3000, sentApplication, handleSetPreferencesStep, handleSetMultiLeadStep, handleModalClose} = props;
    const [timeoutFinished, setTimeoutFinished] = useState(false);

    // Multilead functionality - only enabled when feature flag is true
    const {propertyId, offerId} = useOpenedLeadModalRequiredParams("property");
    const {data: propertyDetail, isLoading: isPropertyLoading} = useGetPropertyDetailApplicationQuery(propertyId);

    const [distanceInKm, setDistanceInKm] = useState(2);

    const {isLoading: recommendationsLoading, recommendedProperties} = useLeadModalParamsRecommendations({
        distanceInKm,
        skip: !rpFeatureFlagMultiLeadInsideConversations
    });
    useEffect(() => {
        const timeout = setTimeout(() => {
            setTimeoutFinished(true);
        }, minLoaderDuration);

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    const isLoading = rpFeatureFlagMultiLeadInsideConversations ? recommendationsLoading || !timeoutFinished : !timeoutFinished || isPropertyLoading;

    useEffect(() => {
        const isPoland = propertyDetail?.country === Country.POLAND;
        const hasNoRecommendations = !isLoading && recommendedProperties && !recommendedProperties.length;
        const hasRecommendations = !isLoading && recommendedProperties && recommendedProperties.length;

        if (!rpFeatureFlagMultiLeadInsideConversations && sentApplication && isPoland) {
            // Default behavior when multilead is disabled
            handleSetPreferencesStep({
                originalApplicationResponse: sentApplication,
                multiLeadSummaryItems: [],
                propertyId,
                offerId
            });
            return;
        }

        // Multilead functionality when feature flag is enabled
        if (hasRecommendations) {
            handleSetMultiLeadStep?.({
                originalApplicationResponse: sentApplication,
                recommendedOffers: recommendedProperties,
                shouldCloseOnOverlayClick: false,
                multiLeadProperty: propertyDetail,
                recommendationsWithPriceFilter: false
            });
            return;
        }

        if (!isLoading && hasNoRecommendations && distanceInKm === 2) {
            setDistanceInKm(5);
            return;
        }

        if (!isLoading && hasNoRecommendations && distanceInKm === 5 && isPoland) {
            handleSetPreferencesStep({
                originalApplicationResponse: sentApplication,
                multiLeadSummaryItems: [],
                propertyId,
                offerId
            });
            return;
        }

        // Fallback to preferences when no multilead data available
        if (!isLoading && sentApplication && isPoland) {
            handleSetPreferencesStep({
                originalApplicationResponse: sentApplication,
                multiLeadSummaryItems: [],
                propertyId,
                offerId
            });

            return;
        }

        if (!isLoading) {
            handleModalClose(false);
        }
    }, [recommendedProperties, distanceInKm, isLoading, sentApplication, propertyDetail]);

    if (isLoading) {
        return customLoader ?? <Loader />;
    }

    return null;
}

LeadModalPriceConversationChatRedirect.PreFetch = () => {
    return (
        <LeadModalPriceConversationChatRedirect
            handleSetPreferencesStep={noop}
            sentApplication={null}
            handleSetMultiLeadStep={noop}
            handleModalClose={noop}
            customLoader={<span />}
        />
    );
};
import {ReactNode, useEffect, useState} from "react";

import {Loader} from "@pg-design/loader-module";
import {noop} from "@pg-mono/nodash";
import {Country} from "@pg-rp/common-types";

import {rpFeatureFlagMultiLeadInsideConversations} from "../../../../../../app/read_rp_environment_variables";
import {IApplication} from "../../../../../../application/types/IApplication";
import {IMultiLeadStepPayload} from "../../../../../../application/types/IMultiLeadStepPayload";
import {ISetPreferencesStepPayload} from "../../../../../../application/types/ISetPreferencesStepPayload";
import {useGetPropertyDetailApplicationQuery} from "../../../../../../property/api/get_property_detail";
import {useLeadModalParamsRecommendations} from "../../../../../hooks/use_lead_modal_params_recommendations";
import {useOpenedLeadModalRequiredParams} from "../../../../../hooks/use_lead_modal_required_params";

interface IProps {
    sentApplication: IApplication | null;
    handleSetPreferencesStep: (payload: ISetPreferencesStepPayload) => void;
    handleSetMultiLeadStep: ((payload: IMultiLeadStepPayload) => void) | undefined;
    handleModalClose: (forceClose: boolean) => void;
    customLoader?: ReactNode;
    minLoaderDuration?: number;
}

export function LeadModalPriceConversationChatRedirect(props: IProps) {
    const {customLoader, minLoaderDuration = 3000, sentApplication, handleSetPreferencesStep, handleSetMultiLeadStep, handleModalClose} = props;
    const [timeoutFinished, setTimeoutFinished] = useState(false);

    // Multilead functionality - only enabled when feature flag is true
    const {propertyId, offerId} = useOpenedLeadModalRequiredParams("property");
    const {data: propertyDetail, isLoading: isPropertyLoading} = useGetPropertyDetailApplicationQuery(propertyId);

    const [distanceInKm, setDistanceInKm] = useState(2);

    const {isLoading: recommendationsLoading, recommendedProperties} = useLeadModalParamsRecommendations({
        distanceInKm,
        skip: !rpFeatureFlagMultiLeadInsideConversations
    });
    useEffect(() => {
        const timeout = setTimeout(() => {
            setTimeoutFinished(true);
        }, minLoaderDuration);

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    const isLoading = rpFeatureFlagMultiLeadInsideConversations ? recommendationsLoading || !timeoutFinished : !timeoutFinished || isPropertyLoading;

    useEffect(() => {
        const isPoland = propertyDetail?.country === Country.POLAND;
        const hasNoRecommendations = !isLoading && recommendedProperties && !recommendedProperties.length;
        const hasRecommendations = !isLoading && recommendedProperties && recommendedProperties.length;

        if (!rpFeatureFlagMultiLeadInsideConversations && sentApplication && isPoland) {
            // Default behavior when multilead is disabled
            handleSetPreferencesStep({
                originalApplicationResponse: sentApplication,
                multiLeadSummaryItems: [],
                propertyId,
                offerId
            });
            return;
        }

        // Multilead functionality when feature flag is enabled
        if (hasRecommendations) {
            handleSetMultiLeadStep?.({
                originalApplicationResponse: sentApplication,
                recommendedOffers: recommendedProperties,
                shouldCloseOnOverlayClick: false,
                multiLeadProperty: propertyDetail,
                recommendationsWithPriceFilter: false
            });
            return;
        }

        if (!isLoading && hasNoRecommendations && distanceInKm === 2) {
            setDistanceInKm(5);
            return;
        }

        if (!isLoading && hasNoRecommendations && distanceInKm === 5 && isPoland) {
            handleSetPreferencesStep({
                originalApplicationResponse: sentApplication,
                multiLeadSummaryItems: [],
                propertyId,
                offerId
            });
            return;
        }

        // Fallback to preferences when no multilead data available
        if (!isLoading && sentApplication && isPoland) {
            handleSetPreferencesStep({
                originalApplicationResponse: sentApplication,
                multiLeadSummaryItems: [],
                propertyId,
                offerId
            });

            return;
        }

        if (!isLoading) {
            handleModalClose(false);
        }
    }, [recommendedProperties, distanceInKm, isLoading, sentApplication, propertyDetail]);

    if (isLoading) {
        return customLoader ?? <Loader />;
    }

    return null;
}

LeadModalPriceConversationChatRedirect.PreFetch = () => {
    return (
        <LeadModalPriceConversationChatRedirect
            handleSetPreferencesStep={noop}
            sentApplication={null}
            handleSetMultiLeadStep={noop}
            handleModalClose={noop}
            customLoader={<span />}
        />
    );
};
